import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 0),
   display: 'flex',
   alignItems: 'center',
   justifyContent:'center',
   flexDirection:'column',
   gap: theme.spacing(3),
 
  '& .ODSText': {
    textAlign:'center',
    maxWidth: theme.spacing(100),
  },
  '& .ODSLogos': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
     gap: theme.spacing(1.25),
  
  },
  '& .ODSDivider': {
     height: theme.spacing(3),
     width: theme.typography.pxToRem(1),
     color: theme.palette.divider[7],
  },
  '& .ODSERLogo': {
      width: theme.typography.pxToRem(168), 
    [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(116),
    },
    },
  '& .ODSESLogo': {
    width: theme.typography.pxToRem(230),
     [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(192),
    },
  },
}));
export default StyledBox;
